// src/components/product-rating-summary/product-rating-summary.tsx
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  fragment ProductExternalReviewsMessageFragment on PopUpMessage {\n    title\n    content {\n      ... on EGDSPlainText {\n        accessibility\n        text\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  fragment ProductExternalReviewsFragment on ProductTextInfoSection {\n    title {\n      text\n    }\n    icon {\n      id\n      description\n      token\n    }\n    message {\n      ...ProductExternalReviewsMessageFragment\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  fragment ProductRatingSupportingMessagesFragment on ProductRatingSupportingMessage {\n    ... on EGDSPlainText {\n      text\n      accessibility\n    }\n    ... on ProductRatingLink {\n      link {\n        text\n        disabled\n        action {\n          target\n          useRelativePath\n        }\n        icon {\n          token\n        }\n      }\n      action {\n        text\n      }\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  fragment ProductRatingMetadataFragment on ProductRatingMetadata {\n    seoData {\n      itemprop\n      content\n      itemscope\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  fragment SummaryContentFragment on ProductRatingSummary {\n    __typename\n    primary\n    secondary\n    theme\n    accessibilityLabel\n    supportingMessages {\n      ...ProductRatingSupportingMessagesFragment\n    }\n    icon {\n      id\n      theme\n    }\n  }\n"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n  query ProductRatingSummaryQuery($productIdentifier: ProductIdentifierInput!, $context: ContextInput!) {\n    productRatingSummary(productIdentifier: $productIdentifier, context: $context) {\n      __typename\n      sectionHeadingAccessibilityText\n      summary {\n        ...SummaryContentFragment\n      }\n      metadata {\n        ...ProductRatingMetadataFragment\n      }\n      info {\n        ...ProductExternalReviewsFragment\n      }\n      impressionAnalytics\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
import React9 from "react";
import { gql as gql6, useQuery } from "@apollo/client";
import { EGDSLineSkeleton } from "@egds/react-core/skeleton";
import { EGDSSpacing as EGDSSpacing5 } from "@egds/react-core/spacing";
import { useBexApi as useBexApi2 } from "@shared-ui/bex-api-context";
import { EgClickstreamImpressionTracker } from "@shared-ui/clickstream-analytics-context";
import { useExperiment as useExperiment2 } from "@shared-ui/experiment-context";
import { useMockData } from "@shared-ui/retail-product-type-providers";
// src/components/product-rating-summary/__private/__fragments/external-reviews/external-reviews.tsx
import React2 from "react";
import { gql as gql2 } from "@apollo/client";
import { EGDSIcon } from "@egds/react-core/icons";
import { EGDSMoreInfoTrigger } from "@egds/react-core/more-info-trigger";
import { EGDSSheet, EGDSSheetTransition } from "@egds/react-core/sheet";
import { EGDSSpacing as EGDSSpacing2 } from "@egds/react-core/spacing";
import { EGDSText as EGDSText2 } from "@egds/react-core/text";
import { EGDSToolbar } from "@egds/react-core/toolbar";
import { useBexApi } from "@shared-ui/bex-api-context";
import { useDialog } from "@shared-ui/dialog-context";
import { defaultViewSizes, useMediaQueries } from "@shared-ui/viewport-context";
// src/components/product-rating-summary/__private/__fragments/external-reviews/external-reviews-message.tsx
import React from "react";
import { gql } from "@apollo/client";
import { EGDSExpandoPeek } from "@egds/react-core/expando";
import { EGDSSheetContent } from "@egds/react-core/sheet";
import { EGDSSpacing } from "@egds/react-core/spacing";
import { EGDSParagraph, EGDSText } from "@egds/react-core/text";
var __ProductExternalReviewsMessageFragment = gql(_templateObject());
var ProductExternalReviewsMessage = function(param) {
    var data = param.data;
    var title = data.title, content = data.content;
    var _React_useState = _sliced_to_array(React.useState(false), 2), isDialogDataExpanded = _React_useState[0], setIsDialogDataExpanded = _React_useState[1];
    return /* @__PURE__ */ React.createElement(EGDSSheetContent, null, /* @__PURE__ */ React.createElement(EGDSText, {
        weight: "bold",
        size: 400
    }, title), /* @__PURE__ */ React.createElement(EGDSSpacing, {
        margin: {
            blockstart: "six"
        }
    }, /* @__PURE__ */ React.createElement(EGDSExpandoPeek, {
        isVisible: isDialogDataExpanded,
        handleClick: function() {
            return setIsDialogDataExpanded(function(prevIsVisible) {
                return !prevIsVisible;
            });
        },
        items: 1
    }, content === null || content === void 0 ? void 0 : content.map(function(value, key) {
        return /* @__PURE__ */ React.createElement(EGDSParagraph, {
            key: key
        }, (value === null || value === void 0 ? void 0 : value.__typename) === "EGDSPlainText" && (value === null || value === void 0 ? void 0 : value.text));
    }))));
};
ProductExternalReviewsMessage.displayName = "ProductExternalReviewsMessage";
ProductExternalReviewsMessage.fragment = __ProductExternalReviewsMessageFragment;
// src/components/product-rating-summary/__private/__fragments/external-reviews/external-reviews.tsx
var __ProductExternalReviewsFragment = gql2(_templateObject1(), ProductExternalReviewsMessage.fragment);
var ProductExternalReviews = function(param) {
    var data = param.data;
    var title = data.title, icon = data.icon, message = data.message;
    var _useDialog = _sliced_to_array(useDialog("product-external-reviews-dialog"), 3), isDialogOpen = _useDialog[0], dialogActions = _useDialog[1], DialogComponent = _useDialog[2];
    var viewSize = useMediaQueries({
        viewSizes: defaultViewSizes
    });
    var context = useBexApi().context;
    var isTabletOrBigger = viewSize === 0 ? context.device.type === "DESKTOP" || context.device.type === "MOBILE_TABLET" : viewSize > defaultViewSizes.SMALL;
    var sheetSize = isTabletOrBigger ? "small" : "medium";
    var openReviewDisclaimerDialog = function() {
        dialogActions.openDialog();
    };
    var handleToolbarCloseAction = function() {
        dialogActions.closeDialog();
    };
    if (!message || !title) {
        return null;
    }
    return /* @__PURE__ */ React2.createElement(React2.Fragment, null, /* @__PURE__ */ React2.createElement(EGDSText2, null, /* @__PURE__ */ React2.createElement(EGDSSpacing2, null, /* @__PURE__ */ React2.createElement(EGDSMoreInfoTrigger, {
        onClick: openReviewDisclaimerDialog,
        size: "medium",
        weight: "regular"
    }, /* @__PURE__ */ React2.createElement(EGDSText2, null, title.text, /* @__PURE__ */ React2.createElement(EGDSIcon, {
        name: (icon === null || icon === void 0 ? void 0 : icon.token) || "",
        description: icon === null || icon === void 0 ? void 0 : icon.description,
        id: icon === null || icon === void 0 ? void 0 : icon.id,
        title: icon === null || icon === void 0 ? void 0 : icon.id
    }))))), /* @__PURE__ */ React2.createElement(EGDSSheetTransition, {
        isVisible: isDialogOpen
    }, /* @__PURE__ */ React2.createElement(DialogComponent, null, /* @__PURE__ */ React2.createElement(EGDSSheet, {
        isVisible: isDialogOpen,
        type: "centered",
        centeredSheetSize: sheetSize,
        triggerRef: null
    }, /* @__PURE__ */ React2.createElement(EGDSToolbar, {
        navigationContent: {
            onClick: handleToolbarCloseAction,
            navIconLabel: "close toolbar",
            navType: "close"
        }
    }), message && /* @__PURE__ */ React2.createElement(ProductExternalReviewsMessage, {
        data: message
    })))));
};
ProductExternalReviews.displayName = "ProductExternalReviews";
ProductExternalReviews.fragment = __ProductExternalReviewsFragment;
// src/components/product-rating-summary/__private/__fragments/messages.tsx
import React3 from "react";
import { gql as gql3 } from "@apollo/client";
import { EGDSIcon as EGDSIcon2 } from "@egds/react-core/icons";
import { EGDSLink } from "@egds/react-core/link";
import { EGDSText as EGDSText3 } from "@egds/react-core/text";
var __ProductRatingSupportingMessagesFragment = gql3(_templateObject2());
var ProductRatingSupportingMessages = function(param) {
    var data = param.data, handleClick = param.handleClick, triggerRef = param.triggerRef;
    var render = function(supportingMessageData, handleClickEvent, triggerReff) {
        var _supportingMessageData_link;
        var token = ((supportingMessageData === null || supportingMessageData === void 0 ? void 0 : (_supportingMessageData_link = supportingMessageData.link) === null || _supportingMessageData_link === void 0 ? void 0 : _supportingMessageData_link.icon) || "").token;
        switch(supportingMessageData.__typename){
            case "EGDSPlainText":
                return (supportingMessageData === null || supportingMessageData === void 0 ? void 0 : supportingMessageData.text) && /* @__PURE__ */ React3.createElement(EGDSText3, null, supportingMessageData.text);
            case "ProductRatingLink":
                var _supportingMessageData_link1;
                return (supportingMessageData === null || supportingMessageData === void 0 ? void 0 : (_supportingMessageData_link1 = supportingMessageData.link) === null || _supportingMessageData_link1 === void 0 ? void 0 : _supportingMessageData_link1.text) && /* @__PURE__ */ React3.createElement(EGDSLink, {
                    onClick: handleClickEvent,
                    domRef: triggerReff
                }, /* @__PURE__ */ React3.createElement("button", {
                    type: "button",
                    "data-stid": "reviews-link"
                }, supportingMessageData.link.text, /* @__PURE__ */ React3.createElement(EGDSIcon2, {
                    name: token
                })));
            default:
                return null;
        }
    };
    return render(data, handleClick, triggerRef);
};
ProductRatingSupportingMessages.displayName = "ProductRatingSupportingMessages";
ProductRatingSupportingMessages.fragment = __ProductRatingSupportingMessagesFragment;
// src/components/product-rating-summary/__private/__fragments/meta-data.tsx
import React4 from "react";
import { gql as gql4 } from "@apollo/client";
var __ProductRatingMetadataFragment = gql4(_templateObject3());
var ProductRatingMetadata = function(param) {
    var seoData = param.data.seoData;
    return /* @__PURE__ */ React4.createElement("div", {
        itemProp: "aggregateRating",
        itemScope: true,
        itemType: "https://schema.org/AggregateRating"
    }, seoData.map(function(param) {
        var itemprop = param.itemprop, content = param.content;
        return content ? /* @__PURE__ */ React4.createElement("meta", {
            itemProp: itemprop,
            content: content,
            key: itemprop
        }) : null;
    }));
};
ProductRatingMetadata.displayName = "ProductRatingMetadata";
ProductRatingMetadata.fragment = _object_spread_props(_object_spread({}, __ProductRatingMetadataFragment), {
    __typename: "ProductRatingMetadata"
});
// src/components/product-rating-summary/__private/__fragments/summary-content.tsx
import React8 from "react";
import { gql as gql5 } from "@apollo/client";
import { EGDSIcon as EGDSIcon3, EGDSIconSize } from "@egds/react-core/icons";
import { EGDSHeading, EGDSText as EGDSText4 } from "@egds/react-core/text";
import { useClickTracker } from "@shared-ui/clickstream-analytics-context";
import { Experiment, ExperimentControl, ExperimentVariant, useExperiment } from "@shared-ui/experiment-context";
// ../internal/src/components/product-standard-badge/product-standard-badge.tsx
import React5 from "react";
import { EGDSBadgeSize, EGDSBadgeStandard } from "@egds/react-core/badge";
// ../internal/src/components/product-standard-badge/__private/product-standard-badge-mapper.tsx
var productStandardBadgeMapper = {
    STANDARD: "standard",
    EMPHASIS: "emphasis",
    INFO: "info",
    FEATURED: "featured",
    BRAND: "brand",
    WARNING: "warning",
    POSITIVE: "positive"
};
// ../internal/src/components/product-standard-badge/product-standard-badge.tsx
var ProductStandardBadge = function(param) {
    var text = param.text, badgeTheme = param.badgeTheme, badgeSize = param.badgeSize;
    var _ref;
    var size = (_ref = badgeSize && EGDSBadgeSize[badgeSize.toUpperCase()]) !== null && _ref !== void 0 ? _ref : EGDSBadgeSize.LARGE;
    var theme = productStandardBadgeMapper[badgeTheme === null || badgeTheme === void 0 ? void 0 : badgeTheme.toUpperCase()] || productStandardBadgeMapper.STANDARD;
    return /* @__PURE__ */ React5.createElement(EGDSBadgeStandard, {
        text: text,
        size: size,
        theme: theme
    });
};
// src/components/product-rating-summary/__private/__fragments/summary-content.tsx
import { IdentifierType as topRatedIdentifierType, ProductTopRatedAttribute, ProductTopRatedAttributePresent } from "@shared-ui/retail-product-top-rated-attribute";
import { IdentifierType, UserGeneratedContentContainer } from "@shared-ui/retail-product-user-generated-content-container";
import { ViewLarge, Viewport, ViewSmall } from "@shared-ui/viewport-context";
// src/components/product-rating-summary/__private/analytics.ts
var SummaryAnalyticsMapping = _define_property({}, "REVIEWS" /* REVIEWS */ , [
    "HOT.HIS.UGC.ViewAllResults",
    "Display detailed reviews"
]);
var EVENT_VERSION = "1.1.0";
// src/components/product-rating-summary/__private/__fragments/review-link-next-to-badge.tsx
import React6 from "react";
import { EGDSLayoutFlex } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing3 } from "@egds/react-core/spacing";
var ReviewLinkNextToBadge = function(param) {
    var theme = param.theme, primary = param.primary, secondary = param.secondary, accessibilityLabel = param.accessibilityLabel, icon = param.icon, supportingMessages = param.supportingMessages, handleClick = param.handleClick, triggerRef = param.triggerRef, productIdentifierId = param.productIdentifierId, travelSearchCriteria = param.travelSearchCriteria;
    return /* @__PURE__ */ React6.createElement(React6.Fragment, null, /* @__PURE__ */ React6.createElement(EGDSLayoutFlex, null, /* @__PURE__ */ React6.createElement(EGDSSpacing3, {
        margin: {
            blockend: "one",
            inlineend: "four"
        }
    }, /* @__PURE__ */ React6.createElement(EGDSLayoutFlex, {
        alignItems: "center",
        space: "two"
    }, theme ? /* @__PURE__ */ React6.createElement(RatingWithProminence, {
        primary: primary,
        theme: theme,
        secondary: secondary,
        accessibilityLabel: accessibilityLabel
    }) : /* @__PURE__ */ React6.createElement(RatingWithoutProminence, {
        primary: primary,
        icon: icon,
        accessibilityLabel: accessibilityLabel
    }))), /* @__PURE__ */ React6.createElement(EGDSSpacing3, {
        margin: {
            inlinestart: "one"
        }
    }, /* @__PURE__ */ React6.createElement(EGDSLayoutFlex, null, supportingMessages && supportingMessages.length > 0 && supportingMessages.map(function(message, index) {
        return /* @__PURE__ */ React6.createElement(EGDSLayoutFlex, {
            key: "".concat(index, "-message-").concat(message.__typename),
            alignItems: "center"
        }, /* @__PURE__ */ React6.createElement(ProductRatingSupportingMessages, {
            data: message,
            handleClick: handleClick,
            triggerRef: triggerRef
        }));
    })))), /* @__PURE__ */ React6.createElement(EGDSSpacing3, {
        margin: {
            blockstart: "two"
        }
    }, /* @__PURE__ */ React6.createElement(EGDSLayoutFlex, null, /* @__PURE__ */ React6.createElement(UserGeneratedContentVariants, {
        productIdentifierId: productIdentifierId,
        travelSearchCriteria: travelSearchCriteria
    }))), /* @__PURE__ */ React6.createElement(EGDSLayoutFlex, null, /* @__PURE__ */ React6.createElement(ProductTopRatedAttributeWrapper, {
        id: productIdentifierId,
        travelSearchCriteria: travelSearchCriteria
    })));
};
// src/components/product-rating-summary/__private/__fragments/reviews.tsx
import React7 from "react";
import { EGDSLayoutFlex as EGDSLayoutFlex2 } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing4 } from "@egds/react-core/spacing";
var Reviews = function(param) {
    var theme = param.theme, primary = param.primary, secondary = param.secondary, accessibilityLabel = param.accessibilityLabel, icon = param.icon, supportingMessages = param.supportingMessages, handleClick = param.handleClick, triggerRef = param.triggerRef, productIdentifierId = param.productIdentifierId, travelSearchCriteria = param.travelSearchCriteria;
    return /* @__PURE__ */ React7.createElement(React7.Fragment, null, /* @__PURE__ */ React7.createElement(EGDSSpacing4, {
        margin: {
            blockend: "two"
        }
    }, /* @__PURE__ */ React7.createElement(EGDSLayoutFlex2, {
        alignItems: "center",
        space: "two"
    }, theme ? /* @__PURE__ */ React7.createElement(RatingWithProminence, {
        primary: primary,
        theme: theme,
        secondary: secondary,
        accessibilityLabel: accessibilityLabel
    }) : /* @__PURE__ */ React7.createElement(RatingWithoutProminence, {
        primary: primary,
        icon: icon,
        accessibilityLabel: accessibilityLabel
    }))), /* @__PURE__ */ React7.createElement(UserGeneratedContentVariants, {
        productIdentifierId: productIdentifierId,
        travelSearchCriteria: travelSearchCriteria
    }), /* @__PURE__ */ React7.createElement(ProductTopRatedAttributeWrapper, {
        id: productIdentifierId,
        travelSearchCriteria: travelSearchCriteria
    }), supportingMessages && supportingMessages.length > 0 && supportingMessages.map(function(message, index) {
        return /* @__PURE__ */ React7.createElement(EGDSSpacing4, {
            key: "".concat(index, "-message-").concat(message.__typename),
            margin: {
                inlinestart: "two"
            }
        }, /* @__PURE__ */ React7.createElement(ProductRatingSupportingMessages, {
            data: message,
            handleClick: handleClick,
            triggerRef: triggerRef
        }));
    }));
};
// src/components/product-rating-summary/__private/__fragments/summary-content.tsx
var __SummaryContentFragment = gql5(_templateObject4());
var UserGeneratedContentVariants = function(param) {
    var productIdentifierId = param.productIdentifierId, travelSearchCriteria = param.travelSearchCriteria;
    return /* @__PURE__ */ React8.createElement(UserGeneratedContentContainer, {
        inputs: {
            productIdentifier: {
                id: productIdentifierId,
                type: IdentifierType.PROPERTY_ID,
                travelSearchCriteria: travelSearchCriteria
            }
        },
        skipSsr: true
    });
};
var RatingWithProminence = function(param) {
    var primary = param.primary, theme = param.theme, secondary = param.secondary, accessibilityLabel = param.accessibilityLabel;
    return /* @__PURE__ */ React8.createElement(React8.Fragment, null, primary && theme && /* @__PURE__ */ React8.createElement(ProductStandardBadge, {
        text: primary,
        badgeTheme: theme
    }), secondary && /* @__PURE__ */ React8.createElement(EGDSHeading, {
        tag: "h3",
        size: 5,
        "aria-label": accessibilityLabel !== null && accessibilityLabel !== void 0 ? accessibilityLabel : void 0
    }, secondary));
};
var RatingWithoutProminence = function(param) {
    var primary = param.primary, icon = param.icon, accessibilityLabel = param.accessibilityLabel;
    return /* @__PURE__ */ React8.createElement(React8.Fragment, null, icon && /* @__PURE__ */ React8.createElement(EGDSIcon3, {
        name: icon.id,
        size: EGDSIconSize.MEDIUM,
        theme: icon.theme || "default"
    }), accessibilityLabel && /* @__PURE__ */ React8.createElement("span", {
        className: "is-visually-hidden"
    }, accessibilityLabel), /* @__PURE__ */ React8.createElement(EGDSText4, {
        size: 500,
        weight: "bold",
        theme: "default",
        "aria-hidden": accessibilityLabel !== null
    }, primary));
};
var ProductTopRatedAttributeWrapper = function(param) {
    var id = param.id, travelSearchCriteria = param.travelSearchCriteria;
    return /* @__PURE__ */ React8.createElement(Experiment, {
        name: "PDP_Top_Rated_Properties_Feature_Gate_for_Web"
    }, /* @__PURE__ */ React8.createElement(ExperimentControl, null), /* @__PURE__ */ React8.createElement(ExperimentVariant, {
        bucket: 1
    }, /* @__PURE__ */ React8.createElement(ProductTopRatedAttribute, {
        inputs: {
            productIdentifier: {
                id: id,
                type: topRatedIdentifierType.PROPERTY_ID,
                travelSearchCriteria: travelSearchCriteria
            }
        },
        skipSsr: true,
        present: ProductTopRatedAttributePresent.PROPERTY_SUMMARY
    })));
};
var SummaryContent = function(param) {
    var data = param.data, triggerRef = param.triggerRef, onClickReviews = param.onClickReviews, productIdentifierId = param.productIdentifierId, isDateless = param.isDateless, travelSearchCriteria = param.travelSearchCriteria;
    var track = useClickTracker();
    var handleClick = React8.useCallback(function(event) {
        event.preventDefault();
        var _SummaryAnalyticsMapping_REVIEWS = _sliced_to_array(SummaryAnalyticsMapping["REVIEWS" /* REVIEWS */ ], 2), id = _SummaryAnalyticsMapping_REVIEWS[0], description = _SummaryAnalyticsMapping_REVIEWS[1];
        track(id, description, true);
        onClickReviews();
    }, [
        onClickReviews,
        track
    ]);
    var _useExperiment_exposure = useExperiment("PDP_MODULARISED_LOCATION_SECTION").exposure, isModularised = _useExperiment_exposure.bucket;
    var _ref = data || {}, primary = _ref.primary, secondary = _ref.secondary, theme = _ref.theme, supportingMessages = _ref.supportingMessages, accessibilityLabel = _ref.accessibilityLabel, icon = _ref.icon;
    var reviewProps = {
        theme: theme,
        primary: primary,
        secondary: secondary,
        accessibilityLabel: accessibilityLabel,
        icon: icon,
        supportingMessages: supportingMessages,
        handleClick: handleClick,
        triggerRef: triggerRef,
        productIdentifierId: productIdentifierId,
        travelSearchCriteria: travelSearchCriteria
    };
    return /* @__PURE__ */ React8.createElement(Viewport, null, /* @__PURE__ */ React8.createElement(ViewSmall, null, /* @__PURE__ */ React8.createElement(Reviews, _object_spread({}, reviewProps))), /* @__PURE__ */ React8.createElement(ViewLarge, null, isModularised ? /* @__PURE__ */ React8.createElement(ReviewLinkNextToBadge, _object_spread({}, reviewProps)) : /* @__PURE__ */ React8.createElement(Reviews, _object_spread({}, reviewProps))));
};
SummaryContent.displayName = "SummaryContent";
SummaryContent.fragment = __SummaryContentFragment;
// src/components/product-rating-summary/product-rating-summary.tsx
var __Query = gql6(_templateObject5(), ProductRatingSupportingMessages.fragment, ProductRatingMetadata.fragment, SummaryContent.fragment, ProductExternalReviews.fragment);
var LoadingPlaceholder = function() {
    return /* @__PURE__ */ React9.createElement(React9.Fragment, null, /* @__PURE__ */ React9.createElement(EGDSSpacing5, {
        margin: {
            blockend: "two"
        }
    }, /* @__PURE__ */ React9.createElement(EGDSLineSkeleton, {
        animation: true
    })), /* @__PURE__ */ React9.createElement(EGDSSpacing5, {
        margin: {
            blockend: "two"
        }
    }, /* @__PURE__ */ React9.createElement(EGDSLineSkeleton, {
        animation: true,
        type: "secondary"
    })));
};
var ProductRatingSummary = function(param) {
    var inputs = param.inputs, skipSsr = param.skipSsr, className = param.className, onClickReviews = param.onClickReviews, triggerRef = param.triggerRef, batchKey = param.batchKey, _param_isDataRequired = param.isDataRequired, isDataRequired = _param_isDataRequired === void 0 ? false : _param_isDataRequired;
    var _variables_productIdentifier_travelSearchCriteria_property_primary, _variables_productIdentifier_travelSearchCriteria_property, _variables_productIdentifier_travelSearchCriteria, _variables_productIdentifier, _mockData_product, _mockData_product1, _variables_productIdentifier1;
    var mockData = useMockData();
    var context = useBexApi2().context;
    var DEFAULT_BATCH_KEY = "default-product-details-experience-batch-key";
    var variables = _object_spread_props(_object_spread({}, inputs), {
        context: context
    });
    var isDateless = !(variables === null || variables === void 0 ? void 0 : (_variables_productIdentifier = variables.productIdentifier) === null || _variables_productIdentifier === void 0 ? void 0 : (_variables_productIdentifier_travelSearchCriteria = _variables_productIdentifier.travelSearchCriteria) === null || _variables_productIdentifier_travelSearchCriteria === void 0 ? void 0 : (_variables_productIdentifier_travelSearchCriteria_property = _variables_productIdentifier_travelSearchCriteria.property) === null || _variables_productIdentifier_travelSearchCriteria_property === void 0 ? void 0 : (_variables_productIdentifier_travelSearchCriteria_property_primary = _variables_productIdentifier_travelSearchCriteria_property.primary) === null || _variables_productIdentifier_travelSearchCriteria_property_primary === void 0 ? void 0 : _variables_productIdentifier_travelSearchCriteria_property_primary.dateRange);
    var _useExperiment2_exposure = useExperiment2("PDP_MODULARISED_LOCATION_SECTION").exposure, isShowingModularisedSection = _useExperiment2_exposure.bucket;
    var _useQuery = useQuery(__Query, {
        context: {
            useApq: true,
            batchKey: batchKey !== null && batchKey !== void 0 ? batchKey : DEFAULT_BATCH_KEY
        },
        variables: variables,
        ssr: !skipSsr,
        skip: mockData === null || mockData === void 0 ? void 0 : (_mockData_product = mockData.product) === null || _mockData_product === void 0 ? void 0 : _mockData_product.productRatingSummary
    }), data = _useQuery.data, error = _useQuery.error, loading = _useQuery.loading;
    if (error) {
        return null;
    }
    var _data_productRatingSummary;
    var productRatingSummary = (_data_productRatingSummary = data === null || data === void 0 ? void 0 : data.productRatingSummary) !== null && _data_productRatingSummary !== void 0 ? _data_productRatingSummary : mockData === null || mockData === void 0 ? void 0 : (_mockData_product1 = mockData.product) === null || _mockData_product1 === void 0 ? void 0 : _mockData_product1.productRatingSummary;
    if (isDataRequired && !productRatingSummary) {
        return loading ? /* @__PURE__ */ React9.createElement(LoadingPlaceholder, null) : null;
    }
    var _ref = productRatingSummary || {}, summary = _ref.summary, metadata = _ref.metadata, sectionHeadingAccessibilityText = _ref.sectionHeadingAccessibilityText, info = _ref.info, impressionAnalytics = _ref.impressionAnalytics;
    var productRatingSummaryContent = /* @__PURE__ */ React9.createElement("div", {
        className: summary ? className : "",
        "data-stid": "content-hotel-reviewsummary"
    }, metadata && /* @__PURE__ */ React9.createElement(ProductRatingMetadata, {
        data: metadata
    }), /* @__PURE__ */ React9.createElement("span", {
        className: "is-visually-hidden"
    }, sectionHeadingAccessibilityText), /* @__PURE__ */ React9.createElement(SummaryContent, {
        onClickReviews: onClickReviews,
        triggerRef: triggerRef,
        data: summary,
        productIdentifierId: inputs.productIdentifier.id,
        isDateless: isDateless,
        travelSearchCriteria: variables === null || variables === void 0 ? void 0 : (_variables_productIdentifier1 = variables.productIdentifier) === null || _variables_productIdentifier1 === void 0 ? void 0 : _variables_productIdentifier1.travelSearchCriteria
    }), info && /* @__PURE__ */ React9.createElement(ProductExternalReviews, {
        data: info
    }));
    if (impressionAnalytics) {
        var impressionAnalyticsData = {
            clientPayload: {
                event: {
                    event_name: "review_score.presented" /* PRESENTED */ ,
                    event_version: EVENT_VERSION
                }
            },
            serverPayload: impressionAnalytics
        };
        return /* @__PURE__ */ React9.createElement(EgClickstreamImpressionTracker, {
            eventData: impressionAnalyticsData
        }, /* @__PURE__ */ React9.createElement(EGDSSpacing5, {
            padding: {
                blockend: "six"
            }
        }, productRatingSummaryContent));
    }
    return productRatingSummaryContent;
};
ProductRatingSummary.displayName = "sharedui-ProductRatingSummary";
// src/__generated__/types.ts
var IdentifierType2 = /* @__PURE__ */ function(IdentifierType3) {
    IdentifierType3["ACTIVITY_ID"] = "ACTIVITY_ID";
    IdentifierType3["CART_ID"] = "CART_ID";
    IdentifierType3["CHECKOUT_SESSION_ID"] = "CHECKOUT_SESSION_ID";
    IdentifierType3["ENTITY_ID"] = "ENTITY_ID";
    IdentifierType3["LEGACY_ORDER_ID"] = "LEGACY_ORDER_ID";
    IdentifierType3["OFFER_ID"] = "OFFER_ID";
    IdentifierType3["ORDER_ID"] = "ORDER_ID";
    IdentifierType3["PROPERTY_ID"] = "PROPERTY_ID";
    IdentifierType3["SAILING_TOKEN"] = "SAILING_TOKEN";
    return IdentifierType3;
}(IdentifierType2 || {});
export { IdentifierType2 as IdentifierType, ProductRatingSummary };
//# sourceMappingURL=index.js.map